module.exports = __webpack_public_path__ + "static/7-9270ff15b40d5a8f1388c6fe87be1284.jpg";